import { render, staticRenderFns } from "./CHomeClosed.vue?vue&type=template&id=1a23ba7a&scoped=true&"
import script from "./CHomeClosed.vue?vue&type=script&lang=js&"
export * from "./CHomeClosed.vue?vue&type=script&lang=js&"
import style0 from "./CHomeClosed.vue?vue&type=style&index=0&id=1a23ba7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23ba7a",
  null
  
)

export default component.exports